var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarseuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.44 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7d00;\n      }\n\n      .cls-2 {\n        fill: #bd1717;\n      }\n\n      .cls-3 {\n        fill: #164193;\n      }\n\n      .cls-4 {\n        fill: #009ee2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 10.69,
    cy: 18.44,
    r: 0.53
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.82,
    cy: 16.56,
    r: 0.53
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 14.2,
    cy: 20.07,
    r: 0.53
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.31,
    cy: 14.93,
    r: 0.53
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 10.78,
    cy: 16.35,
    r: 0.53
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.74,
    cy: 18.65,
    r: 0.53
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.11,
    cy: 19.98,
    r: 0.53
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.4,
    cy: 15.02,
    r: 0.53
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 8.55,
    cy: 18.11,
    r: 0.93
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.96,
    cy: 16.89,
    r: 0.93
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 13.86,
    cy: 22.21,
    r: 0.93
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.65,
    cy: 12.79,
    r: 0.93
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.5,
    cy: 14.6,
    r: 0.93
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.01,
    cy: 20.4,
    r: 0.93
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 10.36,
    cy: 21.26,
    r: 0.93
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.16,
    cy: 13.74,
    r: 0.93
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 5.26,
    cy: 17.54,
    r: 1.56
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 13.3,
    cy: 25.49,
    r: 1.56
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.22,
    cy: 9.51,
    r: 1.56
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.58,
    cy: 11.88,
    r: 1.56
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.93,
    cy: 23.12,
    r: 1.56
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7.63,
    cy: 23.18,
    r: 1.56
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.88,
    cy: 11.82,
    r: 1.56
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.54,13.03l-1.23,1.44c-.78-.63-1.55-.94-2.46-.94s-1.5.39-1.5,1.1.42,1,2.17,1.55c2.12.68,3.33,1.55,3.33,3.62s-1.65,3.54-4.45,3.54c-1.94,0-3.33-.71-4.26-1.6l1.34-1.47c.83.7,1.72,1.1,2.83,1.1s1.78-.52,1.78-1.38-.42-1.2-2.05-1.7c-2.51-.78-3.43-1.81-3.43-3.48,0-1.97,1.72-3.24,4.05-3.24,1.72,0,2.9.5,3.88,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.23,13.9h-2.77v9.17h-2.65v-9.17h-2.9v-2.04h8.58l-.26,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.76,20.67h-3.28l-.57,2.41h-2.75l3.38-11.21h3.22l3.38,11.21h-2.82l-.57-2.41ZM48.29,18.74l-1.18-4.95-1.18,4.95h2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.32,18.79h-1.04v4.29h-2.65v-11.21h3.67c3.04,0,4.61,1.08,4.61,3.41,0,1.47-.7,2.36-2.15,3.03l2.85,4.77h-2.99l-2.3-4.29ZM57.28,16.96h1.12c1.16,0,1.78-.5,1.78-1.68,0-1.08-.63-1.55-1.94-1.55h-.95v3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.76,13.03l-1.23,1.44c-.78-.63-1.55-.94-2.46-.94s-1.5.39-1.5,1.1.42,1,2.17,1.55c2.12.68,3.33,1.55,3.33,3.62s-1.65,3.54-4.45,3.54c-1.94,0-3.33-.71-4.26-1.6l1.34-1.47c.83.7,1.72,1.1,2.83,1.1s1.78-.52,1.78-1.38-.42-1.2-2.05-1.7c-2.51-.78-3.43-1.81-3.43-3.48,0-1.97,1.72-3.24,4.05-3.24,1.72,0,2.9.5,3.88,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.54,13.76h-3.95v2.69h3.45v1.86h-3.45v2.86h4.22v1.91h-6.88v-11.21h6.88l-.28,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M98.74,19.36c0,2.27-1.46,4-4.39,4s-4.37-1.63-4.37-4v-7.49h2.65v7.38c0,1.44.52,2.14,1.72,2.14s1.73-.7,1.73-2.14v-7.38h2.65v7.49Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarseuIcon);
export default __webpack_public_path__ + "static/media/starseu_icon.44b2cc4381f18e3dd22a7ae1f4cfbd0b.svg";
export { ForwardRef as ReactComponent };